__turbopack_context__.v({
  "arrow": "currency-chooser-module__06p0LW__arrow",
  "code": "currency-chooser-module__06p0LW__code",
  "dropdown": "currency-chooser-module__06p0LW__dropdown",
  "open": "currency-chooser-module__06p0LW__open",
  "option": "currency-chooser-module__06p0LW__option",
  "options": "currency-chooser-module__06p0LW__options",
  "selected": "currency-chooser-module__06p0LW__selected",
  "symbol": "currency-chooser-module__06p0LW__symbol",
  "toggle": "currency-chooser-module__06p0LW__toggle",
});
